// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142216/js/" + chunkId + "." + {"44":"6cbb909a","225":"d01fd8e1","481":"3c65b4e6","486":"785f024e","770":"e1e8dc34"}[chunkId] + ".0.024688456657353197.chunk.js";
};